import { render, staticRenderFns } from "./DutiesTaskConf.vue?vue&type=template&id=7bdda1c7"
import script from "./DutiesTaskConf.vue?vue&type=script&lang=js"
export * from "./DutiesTaskConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports